import React from 'react'

import TonConnectUIProvider from './components/TonConnectUIProvider'

// Wallet list is shipped base64-encoded in VITE_WALLETS; a missing or
// malformed value must not take the whole app down at boot.
function readWalletsList(): unknown[] {
    const raw = import.meta.env.VITE_WALLETS
    if (!raw) return []
    try {
        const parsed = JSON.parse(atob(raw))
        return Array.isArray(parsed) ? parsed : []
    } catch (error) {
        console.error('Failed to parse VITE_WALLETS:', error)
        return []
    }
}

/**
 * App-wide TonConnect provider. Every TonConnect hook (`useTonWallet`,
 * `useTonConnectUI`, ...) throws when rendered outside the provider, so it
 * is mounted once at the router root instead of per route.
 */
export default function AppTonConnectProvider({
    children
}: {
    children: React.ReactNode
}) {
    const includeWallets = React.useMemo(readWalletsList, [])
    return (
        <TonConnectUIProvider
            manifestUrl={import.meta.env.VITE_TONWALLET_MANIFEST_URL}
            walletsListConfiguration={{
                includeWallets: includeWallets as never
            }}
        >
            {children}
        </TonConnectUIProvider>
    )
}
